import { SVGProps } from 'react'

export const DocumentationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3334 18.4167V17.0334C13.3334 15.9133 13.3334 15.3532 13.5513 14.9254C13.7431 14.5491 14.049 14.2431 14.4254 14.0514C14.8532 13.8334 15.4132 13.8334 16.5334 13.8334H17.9167M5.83335 6.33341H12.5M5.83335 9.66675H10.8334M5.83335 13.0001H7.50002M12.643 18.8334H10C7.8288 18.8334 6.7432 18.8334 5.86245 18.5557C3.99547 17.9671 2.53304 16.5046 1.94439 14.6376C1.66669 13.7569 1.66669 12.6713 1.66669 10.5001V10.5001C1.66669 8.32887 1.66669 7.24326 1.94439 6.36251C2.53304 4.49553 3.99547 3.0331 5.86245 2.44445C6.7432 2.16675 7.82881 2.16675 10 2.16675V2.16675C12.1712 2.16675 13.2568 2.16675 14.1376 2.44445C16.0046 3.0331 17.467 4.49553 18.0557 6.36251C18.3334 7.24326 18.3334 8.32887 18.3334 10.5001V13.1431C18.3334 14.6522 17.7338 16.0996 16.6667 17.1667V17.1667C15.5995 18.2339 14.1522 18.8334 12.643 18.8334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
